export const fake_flight_offer = () => ({
  type: 'flight-offer',
  id: '1',
  source: 'GDS',
  instantTicketingRequired: false,
  nonHomogeneous: false,
  oneWay: false,
  lastTicketingDate: '2020-01-01',
  numberOfBookableSeats: 3,
  itineraries: [
    {
      duration: 'PT9H25M',
      segments: [
        {
          departure: {
            iataCode: 'SYD',
            terminal: '1',
            at: '2020-01-01T10:00:00',
          },
          arrival: {
            iataCode: 'BKK',
            at: '2020-01-01T15:25:00',
          },
          carrierCode: 'TG',
          number: '476',
          aircraft: {
            code: '747',
          },
          operating: {
            carrierCode: 'TG',
          },
          id: '1',
          numberOfStops: 0,
          blacklistedInEU: false,
        },
      ],
    },
    {
      duration: 'PT9H20M',
      segments: [
        {
          departure: {
            iataCode: 'BKK',
            at: '2020-01-05T17:50:00',
          },
          arrival: {
            iataCode: 'SYD',
            terminal: '1',
            at: '2020-01-06T07:10:00',
          },
          carrierCode: 'TG',
          number: '475',
          aircraft: {
            code: '747',
          },
          operating: {
            carrierCode: 'TG',
          },
          id: '2',
          numberOfStops: 0,
          blacklistedInEU: false,
        },
      ],
    },
  ],
  price: {
    currency: 'EUR',
    total: '1172.52',
    base: '1073.00',
    fees: [
      {
        amount: '0.00',
        type: 'SUPPLIER',
      },
      {
        amount: '0.00',
        type: 'TICKETING',
      },
    ],
  },
  pricingOptions: {
    fareType: ['PUBLISHED'],
    includedCheckedBagsOnly: true,
  },
  validatingAirlineCodes: ['TG'],
  travelerPricings: [
    {
      travelerId: '1',
      fareOption: 'STANDARD',
      travelerType: 'ADULT',
      price: {
        currency: 'EUR',
        total: '1172.52',
        base: '1073.00',
      },
      fareDetailsBySegment: [
        {
          segmentId: '1',
          cabin: 'ECONOMY',
          fareBasis: 'T1YRTTG',
          class: 'T',
          includedCheckedBags: {
            weight: 30,
            weightUnit: 'KG',
          },
        },
        {
          segmentId: '2',
          cabin: 'ECONOMY',
          fareBasis: 'H1YRTTG',
          class: 'H',
          includedCheckedBags: {
            weight: 30,
            weightUnit: 'KG',
          },
        },
      ],
    },
  ],
});
